import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Region } from '@models/Location/region.model';
import { environment } from '../../../environments/environment';

@Injectable()
export class RegionService {
  baseHref = `${environment.apiUrl}/regions`;
  constructor(private http: HttpClient) {}

  findByRegionURL(regionURL): Observable<Region> {
    const url = `${this.baseHref}/${regionURL}`;
    return this.http.get<any>(url);
  }
}
